import { render, staticRenderFns } from "./renameDashboard.vue?vue&type=template&id=21449bd0&scoped=true"
import script from "./renameDashboard.vue?vue&type=script&lang=js"
export * from "./renameDashboard.vue?vue&type=script&lang=js"
import style0 from "./renameDashboard.vue?vue&type=style&index=0&id=21449bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21449bd0",
  null
  
)

export default component.exports